<!-- Filters -->
<share-section-card title="Filters" icon="pi pi-filter" shadow="shadow-1">
  <div cardActions class="flex gap-2">
    <button
      pButton
      icon="pi pi-search"
      label="Apply Filters"
      class="p-button-primary p-button-sm"
      (click)="applyFilters()"
    ></button>
    <button
      pButton
      icon="pi pi-filter-slash"
      label="Clear All"
      class="p-button-outlined p-button-sm"
      (click)="clearFilters()"
    ></button>
  </div>

  <form [formGroup]="filterForm" class="grid p-fluid">
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Action Type</label>
      <input
        pInputText
        type="text"
        formControlName="actionType"
        placeholder="e.g., create, update, delete"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Entity Type</label>
      <input
        pInputText
        type="text"
        formControlName="entityType"
        placeholder="e.g., user, tenant, role"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">User ID</label>
      <input
        pInputText
        type="number"
        formControlName="userId"
        placeholder="User ID"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">IP Address</label>
      <input
        pInputText
        type="text"
        formControlName="ipAddress"
        placeholder="e.g., 192.168.1.1"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Source</label>
      <input
        pInputText
        type="text"
        formControlName="source"
        placeholder="e.g., web, api, system"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Context</label>
      <input
        pInputText
        type="text"
        formControlName="context"
        placeholder="Additional context"
        class="w-full"
      />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Date From</label>
      <p-calendar
        formControlName="dateFrom"
        placeholder="From Date"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        appendTo="body"
        class="w-full"
      ></p-calendar>
    </div>
    <div class="col-12 md:col-6 field">
      <label class="text-500 font-medium">Date To</label>
      <p-calendar
        formControlName="dateTo"
        placeholder="To Date"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        appendTo="body"
        class="w-full"
      ></p-calendar>
    </div>
  </form>

  <!-- Advanced filters -->
  <p-divider></p-divider>
  <div class="flex align-items-center justify-content-between mb-3">
    <span class="text-900 font-semibold">Advanced Filters</span>
    <button
      pButton
      icon="pi pi-plus"
      label="Add Filter"
      class="p-button-outlined p-button-sm"
      (click)="addAdvancedFilter()"
    ></button>
  </div>

  <div *ngFor="let filter of advancedFilters; let i = index" class="grid mb-2">
    <div class="col-12 md:col-3">
      <p-dropdown
        [options]="filterFields"
        [(ngModel)]="filter.field"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Field"
        appendTo="body"
        class="w-full"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="col-12 md:col-3">
      <p-dropdown
        [options]="operators"
        [(ngModel)]="filter.operator"
        optionLabel="label"
        optionValue="value"
        placeholder="Operator"
        appendTo="body"
        class="w-full"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="col-12 md:col-4">
      <input pInputText type="text" [(ngModel)]="filter.value" placeholder="Value" class="w-full" />
    </div>
    <div class="col-12 md:col-2 flex align-items-center">
      <button
        pButton
        icon="pi pi-trash"
        class="p-button-danger p-button-outlined w-full"
        (click)="removeAdvancedFilter(i)"
        pTooltip="Remove Filter"
      ></button>
    </div>
  </div>

  <div *ngIf="advancedFilters.length === 0" class="text-600 text-sm">
    <i class="pi pi-info-circle mr-2"></i>
    No advanced filters. Click "Add Filter" to create custom combinations.
  </div>
</share-section-card>

<!-- Results -->
<share-section-card title="Audit Log Entries" icon="pi pi-list" shadow="shadow-1">
  <p-tag cardActions [value]="'Total: ' + totalRecords" severity="info"></p-tag>

  <ng-container *ngIf="loading">
    <p-skeleton height="2.5rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="2.5rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="2.5rem"></p-skeleton>
  </ng-container>

  <share-table
    *ngIf="!loading"
    [data]="auditLogs$"
    [columns]="columns || []"
    [(metaData)]="metadata"
    (metaDataChange)="loadAuditLogs()"
    (selectedRowObservable$)="viewLogDetails($event)"
  ></share-table>
</share-section-card>
